import { DashboardLayout } from "@/components/layout/DashboardLayout";
import CompetitionView from "@/components/customer/CompetitionView";

export default function CustomerCompetitions() {
  return (
    <DashboardLayout>
      <CompetitionView />
    </DashboardLayout>
  );
}